import { Button, Typography } from '@material-ui/core';
import LoginBanner from 'components/Course/LoginBanner';

import { slugify } from 'utils';
import { IEmbed } from 'interface/lesson';
import { useHistory } from 'react-router-dom';
import { useAppSelector } from 'hooks/redux';
import { ICourse } from 'interface/course';
import makeStyles from '@material-ui/core/styles/makeStyles';

interface IProps {
  embed: IEmbed;
}
const useStyles = makeStyles((theme) => ({
  examContent: {
    backgroundColor: 'rgba(165, 165, 165, 0.1)',
    color: theme.palette.common.white,
    borderRadius: 5,
    textAlign: 'center',
    padding: 30,
  },
}));

const FabricaDeProvasPlayer = ({ embed }: IProps) => {
  const classes = useStyles();
  const history = useHistory();
  const lesson = useAppSelector((state) => state.newLesson.lesson);
  const course = useAppSelector((state) => state.course as ICourse);

  const handleClick = () => {
    const lessonContentId = lesson.contents.filter((c: any) => c.embed && c.embed.loginUrl == embed.loginUrl)[0].id;
    history.push(
      `/curso/${lesson.hash_course}/${course.slug || slugify(course.title)}/aula/${lesson.id}/${lessonContentId}`
    );
  };

  const embedWithError = (
    <LoginBanner
      isAuth={true}
      message={`Não conseguimos carregar o ambiente da prova. Erro: ${embed.error}`}
      route={`/curso/${course.hash}`}
      textButton='Volte para o curso'
    />
  );

  const examContent = (
    <div className={classes.examContent}>
      <Typography gutterBottom variant='subtitle1' color='inherit'>
        Para ter acesso a prova clique no botão abaixo para entrar no ambiente
      </Typography>
      <Button variant='contained' color='primary' onClick={handleClick}>
        Entrar no Ambiente de Prova
      </Button>
    </div>
  );

  return <>{embed.error ? embedWithError : examContent}</>;
};

export default FabricaDeProvasPlayer;
